import apiCall from "components/Api/api";
import { getFormattedDateTime } from "components/Api/common";
import { handleError } from "components/Api/handleError";
import { fetchAllComments } from "components/SharedSafari/utils/sharedSafariUtils";
import { useAuth } from "provider/AuthContext";
import { useSharedSafariContext } from "provider/ShareSafariProvider";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const ReplyForm = ({ parentId, setReplyFormVisibleFor }) => {
    const { safariSlug } = useParams();
    const navigate = useNavigate();
    const { logout, userProfile } = useAuth();
    const { commentsUrl, sharedSafariDispatch } = useSharedSafariContext();
    // Local state for comment text and error handling
    const [comment, setComment] = useState("");
    const [posting, setPosting] = useState(false);
    const [errors, setErrors] = useState({});

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});

        if (!comment.trim()) {
            setErrors({ comment: "Reply cannot be empty." });
            return;
        }

        try {
            setPosting(true);
            const formData = new FormData();
            formData.append("comment", comment);

            const response = await apiCall({
                url: `sharesafari/${safariSlug}/reply?parent_id=${parentId}`,
                method: "POST",
                data: formData,
            });

            if (response.status === 200 || response.status === 201) {
                const apiData = response.data;

                if (apiData?.errors) {
                    Object.keys(apiData.errors).forEach((key) => {
                        const errorMessages = apiData.errors[key];
                        const firstErrorMessage = errorMessages[0];
                        setErrors((prevData) => ({
                            ...prevData,
                            [key]: firstErrorMessage,
                        }));
                    });

                    sharedSafariDispatch({
                        type: "SET_SHARED_SAFARI_VIEW_ERROR",
                        payload: apiData.errors,
                    });

                    return;
                }

                
                // Construct new reply
                const newReply = {
                    id: Math.floor(10000 + Math.random() * 90000),
                    version: 1,
                    parent_id: parentId,
                    safari_operator_id: null,
                    comment: comment,
                    date_time: getFormattedDateTime(),
                    user: {
                        username: userProfile?.username,
                        name: userProfile?.name,
                        email: userProfile?.email,
                        display_name: userProfile?.display_name,
                        profile_display_image: userProfile?.profile_display_image,
                        is_followed: userProfile?.is_followed,
                        // add other fields as needed
                    },
                };
                sharedSafariDispatch({
                    type: "APPEND_REPLY_TO_COMMENT",
                    payload: {
                        parentId,
                        reply: newReply,
                    },
                });
                // await fetchAllComments(commentsUrl, sharedSafariDispatch, logout, navigate);
                setComment("");
                setReplyFormVisibleFor(null)

            } else {
                setErrors({ general: "Failed to post reply. Please try again." });
            }

        } catch (error) {
            setErrors({ general: "An error occurred. Please try again." });
            handleError(error, logout, navigate);
        } finally {
            setPosting(false);
        }
    };
    return (
        <form onSubmit={handleSubmit}>
            <input type="hidden" name="ReplyForm[parent_id]" value={parentId} />
            <div className="mb-3">
                <textarea
                    className={`form-control w-100 ${errors.comment ? "is-invalid" : ""}`}
                    rows="5"
                    placeholder="Write a reply..."
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                />
                {errors.comment && (
                    <div className="invalid-feedback">{errors.comment}</div>
                )}
            </div>
            {errors.general && (
                <div className="text-danger mb-2">{errors.general}</div>
            )}
            <div className="btn-wrapper">
                <button type="submit" className="post-comment" disabled={posting}>
                    {posting ? "Posting..." : "Submit"}
                </button>
            </div>
        </form>
    );
};

export default ReplyForm;
